/** Must match server/src/contracts/catalogKeys.ts CATALOG_CATEGORY_KEYS */
export const ALL_CATALOG_CATEGORY_KEYS = [
  'base_material_spec',
  'base_type_grade',
  'base_source_mill',
  'base_manufacturer',
  'base_heat_number',
  'floor_weld_id',
  'bevel_joint_type',
  'bevel_param_label',
  'backing_requirement',
  'backing_material',
  'project_contractor',
  'project_end_client',
  'project_application',
  'project_welding_code',
  'project_client_spec',
  'project_equipment',
  'preheat_heating_method',
  'preheat_control_method',
  'equipment_clamp_type',
  'equipment_power_supply',
  'postweld_post_heating',
  'postweld_pwht',
  'postweld_cooling_method',
  'report_tag',
  'weld_welding_process',
  'weld_welding_position',
  'weld_welding_direction',
  'weld_welding_system',
  'weld_torch_configuration',
  'weld_torch_split_distance',
  'weld_filler_manufacturer',
  'weld_filler_trade_name',
  'weld_filler_aws_spec',
  'weld_filler_aws_class',
  'weld_filler_heat_no',
  'weld_wire_diameter',
  'weld_shielding_composition',
  'weld_aws_designator',
  'weld_ctwd',
  'weld_string_or_weave',
  'weld_oscillation_rate',
  'weld_oscillation_width',
  'weld_dwell_time',
  'weld_heat_angle',
  'weld_electrical_polarity',
  'team_member_job_title'
] as const

export type CatalogCategoryKey = (typeof ALL_CATALOG_CATEGORY_KEYS)[number]
